// @ts-ignore
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';

import screenWidthsUntyped from '@/tailwind/screenWidths';

export interface ScreenWidth {
  xxs: number;
  xs: number;
  smDialog: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
  xxl: number;
}

const screenWidths = screenWidthsUntyped as ScreenWidth;

export interface WindowDimensions {
  width: number;
  height: number;
}

export interface WindowScrollPos {
  x: number;
  y: number;
}

export const useBreakpoints = () => {
  const store = useStore();

  const windowDimensions = computed<WindowDimensions>(
    () => store.getters['layout/getWindowDimensions'] || { width: 0, height: 0 },
  );

  const windowScrollPos = computed<WindowScrollPos>(
    () => store.getters['layout/getWindowScrollPos'] || { x: 0, y: 0 },
  );

  const bodyWidth = ref<number>(0);

  const windowWidth = ref<number>(0);
  const setWindowWidth = () => {
    if (IS_SSR) {
      return;
    }
    windowWidth.value = window.innerWidth;
    bodyWidth.value = document.body.clientWidth;
  };
  onMounted(() => {
    setWindowWidth();
  });

  const isXXS = computed<boolean>(() => windowWidth.value >= screenWidths.xxs);
  const isXS = computed<boolean>(() => windowWidth.value >= screenWidths.xs);
  const isSmDialog = computed<boolean>(() => windowWidth.value >= screenWidths.smDialog);
  const isSM = computed<boolean>(() => windowWidth.value >= screenWidths.sm);
  const isMD = computed<boolean>(() => windowWidth.value >= screenWidths.md);
  const isLG = computed<boolean>(() => windowWidth.value >= screenWidths.lg);
  const isXL = computed<boolean>(() => windowWidth.value >= screenWidths.xl);

  watch(() => windowDimensions.value.width, setWindowWidth);

  return {
    bodyWidth,
    windowDimensions,
    windowScrollPos,
    windowWidth,
    isXXS,
    isXS,
    isSmDialog,
    isSM,
    isMD,
    isLG,
    isXL,
    screenWidths,
  };
};
